import { Link } from "react-router-dom";
import { Phone, MapPin, Mail } from "lucide-react";
import { BRAND, DEPARTMENTS, NAV_LINKS } from "@/lib/data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-damita-blue text-white">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-14 md:py-20">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-5">
            <Link to="/" className="inline-block mb-6 bg-white p-4 rounded-sm">
              <img
                src={BRAND.logo}
                alt="Bada Biplab Power Solutions"
                className="h-16 md:h-20 w-auto object-contain"
              />
            </Link>
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-damita-yellow mb-3">
              {BRAND.subTagline}
            </div>
            <p className="text-blue-100 text-base max-w-md leading-relaxed">
              A complete power solution for IT &amp; industrial applications. Authorized
              Business Partner of Delta — engineered for the East and Northeast.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-blue-200">
              <span className="px-2 py-1 border border-white/30">Est. 2017</span>
              <span className="px-2 py-1 border border-white/30">Udyam Registered</span>
              <span className="px-2 py-1 border border-white/30">Delta Partner</span>
              <span className="px-2 py-1 border border-white/30">PAN-NE Coverage</span>
            </div>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-damita-yellow mb-4">Navigate</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-blue-100 hover:text-damita-yellow transition-colors text-sm">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-5">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-damita-yellow mb-4">Reach Us</div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={14} className="text-damita-yellow mt-1 shrink-0" />
                <div className="text-blue-100">
                  {BRAND.address.line1}, {BRAND.address.line2}<br />
                  <span className="text-blue-200 text-xs">Besides {BRAND.address.landmark.replace('Besides ', '')} · PIN {BRAND.address.pin}</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={14} className="text-damita-yellow mt-1 shrink-0" />
                <a href={`tel:${BRAND.phoneHref}`} className="text-white hover:text-damita-yellow transition-colors">
                  {BRAND.phone}
                </a>
              </li>
              {DEPARTMENTS.map((d) => (
                <li key={d.id} className="flex items-start gap-3">
                  <Mail size={14} className="text-damita-yellow mt-1 shrink-0" />
                  <div className="flex flex-col">
                    <span className="text-blue-200 text-xs">{d.label}</span>
                    <a href={`mailto:${d.email}`} className="text-white hover:text-damita-yellow transition-colors break-all">{d.email}</a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/20 flex flex-col md:flex-row md:items-center justify-between gap-3 text-blue-200 text-xs font-mono uppercase tracking-[0.18em]">
          <span>© {year} {BRAND.full} · All rights reserved.</span>
          <span>{BRAND.hours} · {BRAND.emergency}</span>
        </div>
      </div>
    </footer>
  );
}
